import { houseData, resetState } from "../actionTypes";

export const loadMultipleHouseData = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case houseData.ADD:
      let data = { ...state };
      if (data[payload.id] === undefined) {
        data[payload.id] = {};
      }
      data[payload.id] = payload.house;
      return data;
    case houseData.UPDATE:
      let data1 = { ...state };
      if (data1[payload.houseId] !== undefined) {
        let rooms = data1[payload.houseId].rooms.map((room) => {
          if (room._id === payload.roomId) {
            return {
              ...room,
              megaControllers: room.megaControllers.map((device) => {
                if (device.deviceId === payload.devices[0].deviceId) {
                  return { ...payload.devices[0] };
                } else {
                  return device;
                }
              }),
            };
          } else {
            return room;
          }
        });
        data1[payload.houseId].rooms = rooms;
      }
      return data1;
    case resetState.RESET:
      return {};
    default:
      return state;
  }
};
